import Loadable from 'react-loadable';

export default Loadable({
	loader: () => import('./Testimonial' /* webpackChunkName: 'Testimonial' */),
	loading: () => null,
	modules: ['Testimonial']
});
